import showToast from '../components/ToastComponent';
import { Dispatch, SetStateAction, useState } from 'react';
import { placeSQSMessageForBulkEmail } from '../service/placeSQSMessageForBulkEmail';

const usePlaceSQSMessage = (): [
  boolean,
  (
    accessToken: string | undefined,
    taskExecutionId: string,
    setCurrentStep: Dispatch<SetStateAction<number>>,
  ) => Promise<void>,
] => {
  const [loading, setLoading] = useState<boolean>(false);

  const placeSQSMessage = async (
    accessToken: string | undefined,
    taskExecutionId: string,
  ) => {
    if (!accessToken) return;

    setLoading(true);

    const response = await placeSQSMessageForBulkEmail(
      accessToken!,
      taskExecutionId,
    );
    if (typeof response === 'number') {
      showToast({
        type: 'warning',
        message: 'Unable to send notification',
      });
      setLoading(false);
      return;
    } else {
      setLoading(false);
      showToast({
        type: 'success',
        message: 'Bulk Email Task Scheduled',
      });
    }
  };

  return [loading, placeSQSMessage];
};

export default usePlaceSQSMessage;
